/**
 * Shallow-merges user overrides into fabric analysis API payloads
 * (fabric_analysis + visual_characteristics sections only).
 */
export function mergeFabricAnalysisResult(base, overrides) {
  if (!overrides || typeof overrides !== 'object') {
    return base && typeof base === 'object' ? base : null;
  }
  const baseObj = base && typeof base === 'object' ? base : {};
  const next = { ...baseObj };
  if (overrides.fabric_analysis && typeof overrides.fabric_analysis === 'object') {
    next.fabric_analysis = {
      ...(baseObj.fabric_analysis || {}),
      ...overrides.fabric_analysis,
    };
  }
  if (overrides.visual_characteristics && typeof overrides.visual_characteristics === 'object') {
    next.visual_characteristics = {
      ...(baseObj.visual_characteristics || {}),
      ...overrides.visual_characteristics,
    };
  }
  return next;
}
